import { useState } from 'react';
import { Box } from '@mui/material';
import { FloatingActionsMenu } from '@elementary/common-ui/components';
import { TestResults } from '@elementary/common-ui/pages';
import useDebounce from '@elementary/common-ui/hooks/useDebounce';
import { DEFAULT_DAYS_BACK } from '@elementary/common-ui/constants';
import useTestResults from './useTestResults';
import useGroupedTestResults from './useGroupedTestResults';

const TestResultsPage = () => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);

  const grouped = useGroupedTestResults({ search: debouncedSearch });
  const { isGrouped } = grouped;
  const flat = useTestResults({ search: debouncedSearch, enabled: !isGrouped });

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {grouped.groupFetchers}
      <TestResults
        tableData={isGrouped ? [] : flat.tableData}
        filterOptions={isGrouped ? grouped.filterOptions : flat.filterOptions}
        isFetching={isGrouped ? grouped.isFetching : flat.isFetching}
        isFilterOptionsFetching={
          isGrouped
            ? grouped.isFilterOptionsFetching
            : flat.isFilterOptionsFetching
        }
        fetchNextPage={isGrouped ? undefined : flat.fetchNextPage}
        hasNextPage={isGrouped ? undefined : flat.hasNextPage}
        groupedData={isGrouped ? grouped.groupedData : undefined}
        onGroupScrollToBottom={
          isGrouped ? grouped.onGroupScrollToBottom : undefined
        }
        daysBack={DEFAULT_DAYS_BACK}
        search={search}
        onSearch={setSearch}
        groupBy={grouped.groupBy}
        onGroupByChange={grouped.onGroupByChange}
        groupableColumnIds={grouped.groupableColumnIds}
      />
      <FloatingActionsMenu />
    </Box>
  );
};

export default TestResultsPage;
